import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
// ✅ อย่าลืม import updateV2Subport เข้ามาด้วย
import { createV2Subport, updateV2Subport, createSubPortfolioTwo, updateSubPortfolioTwo } from '../../composables/fetchAPI';
import { usePortfolio } from '../../context/PortfolioContext';
interface AddSubPortV2ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  portfolioId: string;
  initialData?: any; // ✅ รับข้อมูลเก่ามาถ้าเป็นการแก้ไข
  onOpenAllocation?: () => void; // ✅ 1. เพิ่ม Props นี้เข้ามา
  totalRatio?: number;
  remainingRatio?: number;
  isAllocationOpen?: boolean; // ✅ เพิ่ม Prop เพื่อเช็คว่าเปิดคู่กันไหม
}

const AddSubPortV2Modal: React.FC<AddSubPortV2ModalProps> = ({
  isOpen, onClose, onSave, portfolioId, initialData, onOpenAllocation, totalRatio = 0, remainingRatio = 100, isAllocationOpen = false
}) => {
  const isEditMode = !!initialData; // เช็คว่าเป็นโหมดแก้ไขหรือไม่
  const { displayMode } = usePortfolio(); // ✅ ดึง displayMode จาก context
  const [name, setName] = useState('');
  const [expectedRatio, setExpectedRatio] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ ถ้ามีข้อมูลส่งมา ให้เอาไปยัดใส่ Form
  useEffect(() => {
    if (initialData) {
      setName(initialData.name || '');
      setExpectedRatio(initialData.expectedRatio || 0);
    } else {
      setName('');
      setExpectedRatio(0);
    }
  }, [initialData, isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return toast.error('กรุณากรอกชื่อพอร์ตย่อย');

    // ✅ ตรวจสอบไม่ให้กรอกเกินโควต้าที่เหลืออยู่ (ยกเว้นโหมดแก้ไขที่ต้องหักลบค่าเดิมออกก่อน)
    const ratioToValidate = isEditMode ? (expectedRatio - (initialData.expectedRatio || 0)) : expectedRatio;
    if (ratioToValidate > remainingRatio) {
      return toast.error(`สัดส่วนเกินกำหนด! คุณเหลือโควต้าให้จัดสรรได้อีกแค่ ${remainingRatio}%`);
    }

    setIsLoading(true);
    try {
      if (isEditMode) {
        // ✅ แยก Logic ตาม displayMode
        if (displayMode === 'V2') {
          await updateV2Subport(portfolioId, initialData.subPortId, {
            name: name.trim(),
            expectedRatio: Number(expectedRatio)
          });
        } else {
          // V1 ใช้ฟังก์ชันเดิมที่คุณมี
          await updateSubPortfolioTwo(portfolioId, initialData.subPortId, {
            name: name.trim(),
            expectedRatio: Number(expectedRatio)
          });
        }
        toast.success('อัปเดตพอร์ตย่อยสำเร็จ');
      } else {
        // ✅ แยก Logic ตอนสร้างใหม่
        if (displayMode === 'V2') {
          await createV2Subport(portfolioId, {
            name: name.trim(),
            expectedRatio: Number(expectedRatio)
          });
        } else {
          // V1 ใช้ฟังก์ชันเดิมที่คุณมี
          await createSubPortfolioTwo(portfolioId, {
            name: name.trim(),
            expectedRatio: Number(expectedRatio)
          });
        }
        toast.success('สร้างพอร์ตย่อยสำเร็จ');
      }

      onSave();
      onClose();
    } catch (error: any) {
      console.error('Error saving subport:', error);
      toast.error(error.message || 'เกิดข้อผิดพลาดในการบันทึกพอร์ตย่อย');
    } finally {
      setIsLoading(false);
    }

  };

  if (!isOpen) return null;

  // คำนวณแบบจำลองให้เห็นภาพว่าถ้าใส่เลขนี้ไป จะเหลือเท่าไหร่ (Real-time preview)
  const currentInputRatio = Number(expectedRatio) || 0;
  const originalRatio = isEditMode ? (initialData.expectedRatio || 0) : 0;
  const previewRemaining = remainingRatio - (currentInputRatio - originalRatio);
  const previewTotal = totalRatio + (currentInputRatio - originalRatio);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className={`relative w-full max-w-sm bg-[#18181b] border border-gray-700 rounded-2xl shadow-2xl flex flex-col transition-transform duration-300 ${isAllocationOpen ? 'md:-translate-x-[52%] h-[480px]' : ''}`}>
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-700">
          <h2 className="text-xl font-bold text-yellow-400">
            {isEditMode ? 'แก้ไขพอร์ตย่อย' : 'สร้างพอร์ตย่อย (Subport)'}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-2xl font-bold">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">ชื่อพอร์ตย่อย <span className="text-red-500">*</span></label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-yellow-400"
              placeholder="เช่น พอร์ตปันผล, พอร์ตซิ่ง"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">สัดส่วนเป้าหมาย (%)</label>
            <input
              type="number" min="0" max="100"
              value={expectedRatio}
              onChange={(e) => setExpectedRatio(Number(e.target.value))}
              className="w-full px-4 py-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-yellow-400"
            />
            {/* ✅ 2. ใส่ปุ่มลิงก์ไปหน้า Allocation ตรงนี้ (ตรงกับกรอบแดงภาพที่ 2) */}
            {/* ✅ UI ใหม่: ปุ่มแดงข้างตัวเลข */}
            <div className="flex items-center justify-between mt-3">
              <span className={`text-xs font-medium ${previewRemaining < 0 ? 'text-red-400' : 'text-yellow-500'}`}>
                สัดส่วนที่เหลือในพอร์ตหลัก: {previewRemaining}%
              </span>
              {onOpenAllocation && (
                <button
                  type="button"
                  onClick={onOpenAllocation} // ไม่มีการใส่ onClose() หน้าต่างเก่าจึงไม่ปิด
                  className="bg-[#f05252] hover:bg-red-400 text-white px-3 py-1.5 rounded text-xs font-bold transition-colors shadow-md"
                >
                  แก้ไขสัดส่วน
                </button>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-4 pt-4 border-t border-gray-700">
            <button type="button" onClick={onClose} disabled={isLoading} className="px-5 py-2.5 rounded-lg font-bold text-gray-300 hover:bg-gray-700 transition-colors">ยกเลิก</button>
            <button type="submit" disabled={isLoading} className="px-5 py-2.5 rounded-lg font-bold text-[#18181b] bg-yellow-400 hover:bg-yellow-500 transition-all active:scale-95 disabled:opacity-50">
              {isLoading ? 'กำลังบันทึก...' : (isEditMode ? 'บันทึกการแก้ไข' : 'ยืนยัน')}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
};

export default AddSubPortV2Modal;